<template>
  <v-dialog v-model="dialog" class="ma-0 pa-0 dialog-">
    <div class="pa-0 ma-0 back-white">
      <v-row class="align-center d-flex ma-0 pa-0 pl-3 pt-3  back-556C96 pb-3">
        <h3 class="color-white pl-1">{{ statusTitle }}</h3>
      </v-row>
      <v-row class="ma-0 pa-3 pt-4 pl-5 pb-0 pr-5 aling-center  ">
        <img src="/static/icon/danger.svg" class="mr-3" />
        <h4
          class="color-red align-center d-flex"
          style="width:60%;"
          v-html="statusMessage"
        ></h4>
        <v-spacer />
        <v-btn
          color="#FFFFFF"
          width="120"
          height="30"
          @click="downPlan"
          class="border-739eec"
        >
          <DownloadIcon :fill="viewerRole ? 'grey' : '#0038FF'" class="mr-1" />
          다운로드
        </v-btn>
      </v-row>
      <v-row
        class="ma-0 pa-0 justify-start align-center pl-5 pt-2"
        v-if="roleType == '현장관리자' || roleType == '시스템관리자'"
      >
        <span class="iv-text mr-2">가공업체</span>
        <div style="width:200px;height:30px;">
          <v-select
            height="30"
            hide-details
            solo
            dense
            style="border:1px solid #8A8A8A"
            v-model="invoiceItem"
            :items="invoiceItemList"
            item-value="companyId"
            item-text="companyName"
          ></v-select>
        </div>
      </v-row>

      <v-row justify-center align-center class="ma-0 pa-5 pb-3">
        <v-simple-table class="width-100" fixed-header>
          <template v-slot:default>
            <thead>
              <tr class="back-8ca9dd ">
                <th
                  class="text-center back-8ca9dd color-white border-right-white "
                  rowspan="2"
                >
                  차수
                </th>
                <th
                  class="text-center back-8ca9dd color-white border-right-white "
                  rowspan="2"
                >
                  부위
                </th>
                <th
                  class="text-center back-8ca9dd color-white  border-right-white"
                  rowspan="1"
                  :colspan="materialLength"
                >
                  철근규격(단위:TON)
                </th>
                <th
                  class="text-center back-8ca9dd color-white  border-right-white"
                  rowspan="2"
                >
                  발주수량
                </th>
              </tr>
              <tr>
                <th
                  class="text-center back-8ca9dd color-white border-top-white  border-right-white"
                  v-for="(material, index) in materialList"
                  :key="index"
                >
                  {{ material.rebar_name }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="orderList">
                <td
                  class="border-right-aaaaaa border-bottom-aaaaaa text-center border-left-aaaaaa"
                >
                  {{ orderList.orderName }}
                </td>
                <td
                  class="border-right-aaaaaa border-bottom-aaaaaa text-center border-left-aaaaaa"
                >
                  {{ orderList.partName }}
                </td>
                <td
                  class="border-right-aaaaaa border-bottom-aaaaaa text-center"
                  v-for="(value, index) in orderList.rebarList"
                  :key="index"
                >
                  <span>{{ orderList.rebarList[index] }}</span>
                </td>

                <td
                  class="border-right-aaaaaa border-bottom-aaaaaa text-center"
                >
                  {{ sum(orderList.rebarList) }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-row>
      <v-row class="ma-0 justify-center pa-3 " v-if="status == '승인요청'">
        <v-btn
          color="#739EEC"
          class="color-white ml-5 "
          width="150"
          height="40"
          @click="approvalOrder('N')"
          :disabled="viewerRole"
          v-if="roleType == '현장관리자' || roleType == '시스템관리자'"
        >
          수정요청
        </v-btn>

        <v-btn
          color="#3F557D"
          class="color-white ml-5"
          width="150"
          height="40"
          @click="approvalOrder('Y')"
          :disabled="downCheck || viewerRole"
          v-if="roleType == '현장관리자' || roleType == '시스템관리자'"
        >
          승인
        </v-btn>
        <v-btn
          color="#ffffff"
          class=" ml-5 btn-ff5b5a"
          width="150"
          height="40"
          @click="deleteData"
          :disabled="viewerRole"
        >
          삭제
        </v-btn>
        <v-btn
          color="#EEEEEE"
          class=" ml-5"
          width="150"
          height="40"
          @click="dialog = false"
        >
          닫기
        </v-btn>
      </v-row>
      <v-row class="ma-0 justify-center pa-3" v-if="status == '수정요청'">
        <v-btn
          color="#6C98EB"
          class="color-white "
          width="150"
          height="40"
          @click="reUpload"
          :disabled="viewerRole"
        >
          재업로드
        </v-btn>
        <v-btn
          color="#ffffff"
          class=" ml-5 btn-ff5b5a"
          width="150"
          height="40"
          @click="deleteData"
          :disabled="viewerRole"
        >
          삭제
        </v-btn>

        <v-btn
          color="#EEEEEE"
          class=" ml-5"
          width="150"
          height="40"
          @click="dialog = false"
        >
          닫기
        </v-btn>
      </v-row>
    </div>
  </v-dialog>
</template>

<script>
import OrderApi from "@/api/OrderService";
import Commonality from "@/mixin/Commonality";
import FileApi from "@/api/FileService";
import fileDownload from "@/assets/js/file-download.js";
import InvoiceService from "@/api/InvoiceService";
import ApprovalApi from "@/api/ApprovalService";
import DownloadIcon from "@/assets/svgs/DownloadIcon.vue";

export default {
  mixins: [Commonality],
  components: {
    DownloadIcon,
  },

  created() {
    this.$bus.$on("approalOn", (value) => {
      this.orderId = value;
      this.reset();
      this.dialog = true;
    });
    this.$bus.$on("resetApproval", () => {
      this.dialog = false;
    });
  },

  beforeDestroy() {
    this.$bus.$off("approalOn");
    this.$bus.$off("resetApproval");
  },

  data: () => ({
    orderList: [],
    orderTotalList: [],
    orderId: "",
    dialog: false,
    downCheck: true,
    partName: "",
    status: "",
    invoiceItem: "",
    invoiceItemList: [],
  }),

  computed: {
    materialLength() {
      return this.materialList.length;
    },

    userStatus() {
      return this.$store.getters.getUserList;
    },

    roleType() {
      return this.userStatus.roleType;
    },

    statusMessage() {
      if (this.status == "승인요청")
        return `도면을 다운로드해서 확인 후 승인이 가능합니다.도면 검토 후 발주 입력한 데이터가 맞는지 마지막으로 확인해 주세요.`;
      else
        return `메모를 검토하여 도면을 수정 부탁 드립니다. 수정된 도면은 아래 재 업로드 버튼을 통해 업로드 진행 해 주세요.`;
    },

    statusTitle() {
      if (this.status == "승인요청") return "신규 발주 승인";
      else return "발주 승인 요청";
    },
    viewerRole() {
      return this.$store.getters.getUserList.roleType === "뷰어";
    },
  },
  methods: {
    async deleteData() {
      let data = {
        orderId: this.orderId,
      };
      let returnData = await OrderApi.orderDelete(data);
      let text;
      const isSuccess = returnData.data.success === "ok";
      if (returnData.data.success == "ok")
        text = "발주데이터 삭제가 완료 되었습니다.";
      else text = `${returnData.data.message}`;
      this.$bus.$emit("dialog", text, isSuccess);
      if (isSuccess) {
        this.$bus.$emit("orderNavigationDuplicated");
      }
      this.dialog = false;
    },

    focusClear(val, index) {
      if (val != 0) return;
      let list = [];
      for (let i = 0; i < this.orderList.rebarList.length; i++) {
        if (index != i)
          list.push(
            this.orderList.rebarList[i] == "" ? 0 : this.orderList.rebarList[i],
          );
        else list.push("");
      }
      this.orderList.rebarList = list;
    },

    async deleteData() {
      let data = {
        orderId: this.orderId,
      };
      let returnData = await OrderApi.orderDelete(data);
      let text;
      const isSuccess = returnData.data.success === "ok";
      if (returnData.data.success == "ok")
        text = "발주데이터 삭제가 완료 되었습니다.";
      else text = `${returnData.data.message}`;
      this.$bus.$emit("dialog", text, isSuccess);
      if (isSuccess) {
        this.$bus.$emit("orderNavigationDuplicated");
      }
      this.dialog = false;
    },

    async reset() {
      this.downCheck = true;
      this.$bus.$emit("loadingStart");
      let datas = { orderId: this.orderId };
      let orderTempList = await OrderApi.orderDetail(datas);
      this.orderList = orderTempList.data.orderList;
      this.status = this.orderList.orderStatus;
      this.partName = this.orderList.partName;
      let res = await ApprovalApi.approvalDownCheck(this.orderId);
      this.downCheck = res.data.success != "ok";
      res = await this.getInvoiceCompanyList();

      this.invoiceItemList = res?.data?.companyList;
      this.invoiceItem = res?.data?.companyList[0]?.companyId;
      this.$bus.$emit("loadingEnd");
    },
    /** 발주현황 가공업체 목록 조회 */
    async getInvoiceCompanyList() {
      try {
        const res = await InvoiceService.invoiceConstructionList({
          constructionId: this.constructionId,
        });
        return res;
      } catch (e) {
        console.error(e);
        this.$bus.$emit("loadingEnd");
      } finally {
        this.$bus.$emit("loadingEnd");
      }
    },

    async approvalOrder(status) {
      if (!this.invoiceItem) {
        this.$bus.$emit("dialog", "가공업체 등록 후 진행해주세요.");
        return;
      }
      let res = await ApprovalApi.approval(
        status,
        this.orderId,
        this.invoiceItem,
      );
      let returnText = "";
      if (res.data.success == "ok") {
        returnText =
          status == "Y"
            ? "승인이 완료되었습니다."
            : "수정요청이 완료되었습니다.";
        this.dialog = false;
      } else {
        returnText = "잠시 후 시도해주세요.";
      }
      this.$bus.$emit("orderNavigationDuplicated");
      this.$bus.$emit("dialog", returnText);
    },

    async downPlan() {
      this.$bus.$emit("loadingStart");
      try {
        const res = await FileApi.cadDownload({ orderId: this.orderId });
        fileDownload(
          res.data,
          `${this.constructionName.constructionName}_${this.partName}.${
            res.headers["content-disposition"].split(".")[1]
          }`,
        );
        this.reset();
        this.$bus.$emit("loadingEnd");
      } catch (e) {
        this.$bus.$emit("dialog", "도면 다운로드에 실패했습니다.", false);
        this.$bus.$emit("loadingEnd");
        console.error(e);
      }
      this.$bus.$emit("loadingEnd");
    },

    reUpload() {
      this.$bus.$emit("drawingUpload", this.orderId);
    },

    resetAll() {
      this.dialog = false;
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .v-btn[disabled],
.v-btn:disabled {
  border: 1px solid transparent !important;
}

.border-739eec {
  border: 1px solid #739eec !important;
}
.iv-text {
  font-family: "Noto Sans KR";
  font-size: 18px;
  font-weight: 500;
  line-height: 26px;
  letter-spacing: 0em;
  text-align: left;
}
.color-red {
  color: red;
}
.w-50 {
  width: 50px;
}

.height-94 {
  height: 94px !important;
}

.span-setting1 {
  text-align: center;
  background: #dde0e7;
  border-radius: 25px;
  width: 130px;
  height: 38px;
  vertical-align: middle;
}

.span-setting2 {
  text-align: center;
  background: #dde0e7;
  border-radius: 25px;
  width: 216px;
  height: 38px;
  vertical-align: middle;
}
</style>
